import { render, staticRenderFns } from "./client-index.vue?vue&type=template&id=eea589de"
import script from "./client-index.vue?vue&type=script&lang=js"
export * from "./client-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports